<div class="container mt-5">
    <div class="card card-primary">

        <!-- /.card-header -->
        <!-- form start -->
        <form id="quickForm">
            <div class="card-body">
                <div class="row">
                   <app-loader *ngIf="loader"></app-loader>
                    <div class="col-lg-12">
                        <b>Products Name</b>
                        <select class="form-control" (change)="GetProduct($event.target)">
                            <option selected disabled>Select Products</option>
                            <option *ngFor="let item of productOption" value="{{item.value}}">{{item.label}}</option>
                        </select>
                    </div>
                    <div class="col-lg-12">
                      <b>Discount*</b>
                        <input type="number" placeholder="Discount" #allDiscounts class="form-control">
                    </div>
                    
                </div>

                <!-- <div class="row mt-4">
                    <table id="example2" class="table table-bordered table-hover">
                        <thead>
                            <tr>
                                <th>Logo</th>
                                <th>Name</th>
                                <th>Amount</th>
                                <th>Commission (In %)</th>
                                <th>Commisssion Reatiler</th>
                            </tr>
                        </thead>
                        <!-- <tbody *ngFor="let discount of Products; let i = index;">
                            <tr>
                                <td>{{discount.productTitle}}</td>
                                <td>{{discount.defaultDisplayText}}</td>
                                <td>{{discount.maximum.sendValue}}</td>
                                <td>{{discount.commissionRate*100}}</td>
                                <td>
                                    <input type="text" #discountPercentage> &nbsp;&nbsp;&nbsp;
                                     <i class="fa fa-save" (click)="onSubmit(discount,discountPercentage.value)"></i>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div> -->
            </div>
            <!-- /.card-body -->
            <div class="card-footer">
                <button type="button" class="btn btn-primary" (click)="onSubmit(allDiscounts.value)">Submit</button> &nbsp;&nbsp;
                <button type="button" class="btn btn-outline-dark" (click)="closeModal()">
                    Close
                </button>
            </div>
        </form>
    </div>


</div>